import React, { useCallback } from 'react';
import { Dropdown } from '@bynder/design-system';
import { IconAddToCollection, IconFileMove } from '@bynder/icons';
import { useTranslate } from '@bynder/localization';
import { ActionStatus, Entity, TemplateAction } from 'packages/hooks/useAccessRights/types';
import type { IsAvailable, Props } from './types';
import useAccessRights from 'packages/hooks/useAccessRights';
import { ActiveSplits } from 'packages/store/user/types';

export const isMoveToCategoryAvailable: IsAvailable = ({ isEntityActionAllowed, hiddenActions, template }) =>
    isEntityActionAllowed(TemplateAction.MOVE, Entity.TEMPLATE, template.grantedPermissions) !==
        ActionStatus.NOT_ALLOWED && !hiddenActions.includes('setMoveModalTemplate');

export const MoveToCategory = ({ template, menuActions }: Props) => {
    const { isEntityActionAllowed, isSplitEnabled } = useAccessRights();
    const { translate } = useTranslate();
    const isMultipleCategoriesEnabled = isSplitEnabled(ActiveSplits.studioMultipleTemplateCategories);

    const onClick = useCallback(() => menuActions.setMoveModalTemplate?.([template]), [menuActions, template]);

    const actionStatus = isEntityActionAllowed(TemplateAction.MOVE, Entity.TEMPLATE, template.grantedPermissions);

    return (
        <Dropdown.Item
            isDisabled={actionStatus === ActionStatus.DISABLED}
            icon={isMultipleCategoriesEnabled ? <IconAddToCollection /> : <IconFileMove />}
            onClick={onClick}
        >
            {translate(
                isMultipleCategoriesEnabled
                    ? 'pages.categories.category.template.menu.add'
                    : 'pages.categories.category.template.menu.move',
            )}
        </Dropdown.Item>
    );
};
